import type { ReactNode } from 'react'
import { Truncate } from '@workflow/ui'

export function PaymentSheetList({ children }: { children: ReactNode }) {
  return <ul className="overflow-hidden rounded-2xl border border-hairline bg-surface">{children}</ul>
}

export function PaymentSheetListRow({ title, detail, indicator, children, onOpen }: {
  title: string
  detail: ReactNode
  indicator?: ReactNode
  children: ReactNode
  onOpen: () => void
}) {
  return (
    <li className="border-b border-hairline last:border-0">
      <button
        type="button"
        onClick={onOpen}
        className="flex w-full flex-col items-start gap-2 px-4 py-3.5 text-left transition-colors duration-fast hover:bg-tint focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:flex-row sm:items-center sm:gap-4 sm:px-5"
      >
        <span className="w-full min-w-0 flex-1">
          <span className="flex min-w-0 items-center gap-2">
            <Truncate text={title} className="min-w-0 text-ui font-medium text-foreground" />
            {indicator}
          </span>
          <span className="mt-0.5 block text-caption text-muted-foreground">{detail}</span>
        </span>
        <span className="flex flex-wrap items-center gap-x-4 gap-y-1">{children}</span>
      </button>
    </li>
  )
}
